/**
 * Domain types of the scheduling engine.
 *
 * This package has no runtime dependencies on purpose: it is imported by the
 * NestJS backend and by the React frontend alike, so a bar dragged in the Gantt
 * view is scheduled by exactly the same code that later validates the save on
 * the server (see ADR 0001).
 *
 * Nothing in here touches HTTP, the database or the clock.
 */
export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
/** Renders an error as a German message for the user interface. */
export function describeError(error) {
    switch (error.kind) {
        case 'cycle': {
            const paths = error.cycles.map((c) => c.path.join(' -> ')).join('; ');
            return `Der Vorgangsplan enthaelt einen Ringschluss: ${paths}`;
        }
        case 'unknownTask':
            return `Die Anordnungsbeziehung verweist auf den unbekannten Vorgang ${error.taskId}.`;
        case 'duplicateTask':
            return `Der Vorgang ${error.taskId} kommt mehrfach vor.`;
        case 'invalidDuration':
            return `Der Vorgang ${error.taskId} hat eine unzulaessige Dauer (${error.durationDays}).`;
        case 'invalidConstraintDate':
            return (`Der Vorgang ${error.taskId} hat eine unzulaessige Terminvorgabe ` +
                `(${error.date}).`);
        case 'invalidLag':
            return (`Die Anordnungsbeziehung von ${error.predecessorId} zu ` +
                `${error.successorId} hat einen unzulaessigen Zeitabstand ` +
                `(${error.lagDays}). Nur ganze Arbeitstage sind zulaessig.`);
    }
}
//# sourceMappingURL=types.js.map